import { useEffect } from 'react';
import { DEFAULT_NAMESPACE } from "../constants";
import { useConfiguration, usePersonalBeautyStore } from "../contexts";
import { useLocalizationQuery } from "../hooks";
import { i18n } from "../i18n";
import { ReferralType } from "../models";
import { debug } from "../utils";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export var I18nLocalizationsLoader = function I18nLocalizationsLoader(_ref) {
  var _pbsData$storeInfo2;
  var children = _ref.children;
  // We need to subscribe to provided i18next in react since we are reacting and extending in react
  var _useConfiguration = useConfiguration(),
    isEnabled = _useConfiguration.isEnabled,
    currentLanguage = _useConfiguration.currentLanguage,
    preloadedTranslations = _useConfiguration.translations;
  var pbsData = usePersonalBeautyStore();
  var _useLocalizationQuery = useLocalizationQuery({
      disabled: !isEnabled || !!preloadedTranslations
    }),
    localizationData = _useLocalizationQuery.data;
  useEffect(function () {
    var _pbsData$storeInfo$ty, _pbsData$storeInfo, _ref2;
    if (!isEnabled || ((_pbsData$storeInfo$ty = (_pbsData$storeInfo = pbsData.storeInfo) === null || _pbsData$storeInfo === void 0 ? void 0 : _pbsData$storeInfo.type) !== null && _pbsData$storeInfo$ty !== void 0 ? _pbsData$storeInfo$ty : ReferralType.None) === ReferralType.None) {
      return;
    }
    var localizationPayload = (_ref2 = localizationData !== null && localizationData !== void 0 ? localizationData : preloadedTranslations) !== null && _ref2 !== void 0 ? _ref2 : {};

    // Check if incoming payload is not empty, when needed
    if (Object.keys(localizationPayload).length) {
      i18n.addResourceBundle(currentLanguage, DEFAULT_NAMESPACE, localizationPayload);
      // And finally switch to language
      i18n.changeLanguage(currentLanguage);
      debug("[personal-beauty-store]: Language changed to '".concat(currentLanguage, "' with new resource bundle:\n").concat(JSON.stringify(localizationPayload, null, 2)));
    }
  }, [isEnabled, currentLanguage, localizationData, preloadedTranslations, (_pbsData$storeInfo2 = pbsData.storeInfo) === null || _pbsData$storeInfo2 === void 0 ? void 0 : _pbsData$storeInfo2.type]);

  // eslint-disable-next-line react/jsx-no-useless-fragment -- Can't return ReactNode from FC component
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};